/**
 * Printing-related utility functions
 */

import { Printing } from '../types';

/**
 * Calculate printing progress percentage
 * @param printing - The printing record
 * @returns Formatted percentage string (e.g., "45.67%")
 */
export const calculatePrintingProgress = (printing: Partial<Printing>): string => {
  // Validate totalLines is a positive number
  if (
    !printing.totalLines ||
    typeof printing.totalLines !== 'number' ||
    printing.totalLines === 0
  ) {
    return '0%';
  }

  // Ensure currentLine is a valid number, default to 0
  const currentLine =
    typeof printing.currentLine === 'number' && printing.currentLine >= 0
      ? printing.currentLine
      : 0;

  const percentage = (currentLine / printing.totalLines) * 100;
  return `${percentage.toFixed(2)}%`;
};

/**
 * Check if a printing is in progress
 * @param printing - The printing record
 * @returns true if printing has no endTime, false otherwise
 */
export const isPrintingInProgress = (printing: Partial<Printing>): boolean => {
  return !printing.endTime;
};

/**
 * Check if a printing is completed
 * @param printing - The printing record
 * @returns true if printing has endTime, false otherwise
 */
export const isPrintingCompleted = (printing: Partial<Printing>): boolean => {
  return !!printing.endTime;
};
